import { combineReducers } from "redux";
import createReducer from "utils/createReducer";

import * as form from "./form";
import * as list from "./list";

export default combineReducers({
  form: createReducer(form),
  list: createReducer(list),
});
